import { Flex, Text, Image } from '@chakra-ui/react';
import React, { useState } from 'react';
import { CustomCheckBox } from './globalComponents/CustomCheckBox';
import StreamGoldIcon from '../assets/store/StreamGold.png';

interface CheckboxGroupProps {
    options: string[];
    defaultOption?: string;
    onValueChange: (nextValue: number) => void;
}

export const CustomCheckboxGroup: React.FC<CheckboxGroupProps> = ({
    options,
    defaultOption,
    onValueChange,
}) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(
        defaultOption ? options.indexOf(defaultOption) : 0,
    );

    return (
        <Flex className={'custom-checkbox-group'}>
            {options.map((item, idx) => (
                <Flex className={'custom-checkbox-row'} key={item}>
                    <CustomCheckBox
                        index={idx}
                        isChecked={idx === selectedIndex}
                        onValueChange={(idx) => {
                            setSelectedIndex(idx);
                            onValueChange(idx);
                        }}
                    />
                    <Image src={StreamGoldIcon} />
                    <Text>{item}</Text>
                </Flex>
            ))}
        </Flex>
    );
};
